import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/simulator-configs/save`,
        endpointGetById: `${endpointBackend}gci/simulator-configs/getById`,
        urlGoBack: `/gci/simulator-configs/list`,
        pathView: `/gci/simulator-configs/view`
    }

    const labels = {
        labelTitleAdd: "Novo Configuração - Simulador",
        labelTitleEdit: "Editar Configuração - Simulador",
        labelTitleView: 'Visualizar Configuração - Simulador'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'tax_percent',
                    type: 'decimal',
                    label: 'Percentual de Imposto',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'comission_percent',
                    type: 'decimal',
                    label: 'Percentual de Comissão',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'administration_percent',
                    type: 'decimal',
                    label: 'Percentual de Administração',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'fundraising_percent',
                    type: 'decimal',
                    label: 'Percentual de Captação',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'others_percent',
                    type: 'decimal',
                    label: 'Outros',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
